import { Injectable } from '@angular/core';
import { DeviceDetectorService } from 'ngx-device-detector';
import { SessionStorageService } from './session-storage.service';
import { STORAGE_KEYS } from '../components/dynamic-inputs/util/constants';
// @ts-ignore
import { default as j } from '../../../package.json';

@Injectable({ providedIn: 'root' })
export class MetadataService {
  constructor(
    private deviceService: DeviceDetectorService,
    private localStorageService: SessionStorageService
  ) {}

  getDeviceInfo(): void {
    const devicePixelRatio = window.devicePixelRatio;
    const width = window.screen.width * devicePixelRatio;
    const height = window.screen.height * devicePixelRatio;
    this.localStorageService.saveSessionEntry(STORAGE_KEYS.METADATA, {
      ...this.deviceService.getDeviceInfo(),
      devicePixelRatio,
      width,
      height,
      resolution: `${width * devicePixelRatio}x${height * devicePixelRatio}`,
      version: j.version,
    });
  }
}
